import React from "react";

import TroubleshootIcon from "@mui/icons-material/Troubleshoot";

// -------------------------------------------
const externalAnalysisSection = {
  type: "section",
  title: "Анализ внешки",
  icon: TroubleshootIcon,
  children: [
    {
      title: "Поиск трафика WB",
      url: "/bloggers-search",
      component: React.lazy(() => import("root/pages/bloggers-search/App")),
      exact: false,
    },
    {
      title: "Поиск трафика другие МП",
      url: "/all-bloggers-search",
      component: React.lazy(() => import("root/pages/bloggers-search-for-all/App")),
      exact: false,
    },
    // {
    //   title: "Отчеты по внешке OLD",
    //   url: "/bloggers-data",
    //   component: React.lazy(() => import("root/pages/bloggers/App")),
    //   exact: false,
    // },
    {
      title: "Отчеты по внешке",
      url: "/bloggers_reports",
      component: React.lazy(() => import("root/pages/bloggers_reports/App")),
      exact: false,
    },
    // {
    //   title: "Подбор публикаций",
    //   url: "/bloggers-posts-selection",
    //   component: React.lazy(() => import("root/pages/bloggers-posts-selection/App")),
    //   exact: false,
    // },
    {
      title: "Подбор публикаций",
      url: "/bloggers_posts_selection",
      component: React.lazy(() => import("root/pages/bloggers_posts_selection/App")),
    },
    // {
    //   title: "Поиск блогеров",
    //   url: "/bloggers-profiles-selection",
    //   component: React.lazy(() => import("root/pages/bloggers-profiles-selection/App")),
    //   exact: false,
    // },
    {
      title: "Поиск блогеров",
      url: "/bloggers_profiles_selection",
      component: React.lazy(() => import("root/pages/bloggers_profiles_selection/App")),
    },
    {
      title: "Тренды",
      url: "/bloggers_trends",
      component: React.lazy(() => import("root/pages/bloggers_trends/App")),
    },
    // {
    //   title: "Анализ блогеров",
    //   url: "/blogger-card",
    //   component: React.lazy(() => import("root/pages/blogger-card/App")),
    //   exact: false,
    // },
    {
      title: "Анализ блогеров",
      url: "/blogger_card",
      component: React.lazy(() => import("root/pages/blogger_card/App")),
    },
    {
      url: "/monitoring?tab=7",
      component: React.lazy(() => import("root/pages/monitoring/App")),
      title: "Мониторинг внешки",
      exact: false,
    },
  ],
};

export default externalAnalysisSection;
